export { singlePageDataFetcher } from "./SinglePage.fetcher";
export { SinglePageTemplate } from "./SinglePage.Template";
